import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import {
  selectAllSubmitterUserOptionsFromState,
  selectGettingOutOfPocketExpensesEnabledFromState,
  selectSubmitterUsers,
} from 'src/app/ApproverExpenseReports/redux/approverExpenseReports.selectors'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import ExpenseReportsBox, {
  ExpenseReportsAnalyticsEventProperties,
} from 'src/components/ExpenseReportsBox/ExpenseReportsBox'
import LayoutShell from 'src/components/LayoutShell/LayoutShell'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import { SubnavDesign } from 'src/components/Subnav/Subnav'
import { UserDropdownInfiniteScrollProps } from 'src/components/UserDropdown/UserDropdown'
import { useBackgroundDispatch } from 'src/hooks'
import Trns from 'src/localization/Trns'
import { getSubmitterUsers } from 'src/redux/actions/data/expenses.actions'
import { selectOutOfPocketExpensesVisible } from 'src/redux/selectors/data/organizations.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const ManagerApproverExpenseReports: React.FC = () => {

  const dispatch = useBackgroundDispatch()
  const gettingOutOfPocketExpensesEnabled = useSelector(
    selectGettingOutOfPocketExpensesEnabledFromState,
  )
  const outOfPocketExpensesEnabled = useSelector(
    selectOutOfPocketExpensesVisible,
  )
  const allMemberIdOptions = useSelector(selectAllSubmitterUserOptionsFromState)
  const membersFullPaginatedData = useSelector(selectSubmitterUsers)
  const appName = useSelector(selectAppName)
  const { analytics } = useAnalyticsContext()
  const [selectedFilters, setSelectedFilters] = useState<
    ExpenseReportsAnalyticsEventProperties | undefined
  >(undefined)

  const fetchSubmitterUsers = (): void => {
    dispatch(getSubmitterUsers())
  }

  const userInfiniteScrollProps: UserDropdownInfiniteScrollProps = {
    fetch: fetchSubmitterUsers,
    ...membersFullPaginatedData,
  }

  // analytics
  useEffect(() => {
    if (selectedFilters) {
      analytics?.track(`manager expense reports filter applied`, {
        report_status: selectedFilters.report_status,
        report_submitted_by: selectedFilters.report_submitted_by,
      })
    }
  }, [selectedFilters])

  const content = gettingOutOfPocketExpensesEnabled ? (
    <LoadingBackgroundPage />
  ) : outOfPocketExpensesEnabled ? (
    <>
      <Helmet>
        <title>{`Out-of-Pocket Expenses | ${appName}`}</title>
        <meta
          name="description"
          content={`Out-of-Pocket Expense Reports page of ${appName}`}
        />
      </Helmet>
      <BackgroundPageContent noStackingIndex noPadding>
        <ExpenseReportsBox
          userOptions={allMemberIdOptions}
          userInfiniteScrollProps={userInfiniteScrollProps}
          setSelectedFilters={setSelectedFilters}
          context={'manager'}
        />
      </BackgroundPageContent>
    </>
  ) : (
    <NotFoundBackgroundPageContent />
  )

  return (
    <LayoutShell
      subnavDesign={SubnavDesign.Floating}
      subnavOptions={[]}
      content={content}
      title={<Trns source={'Reimbursements'} />}
      /* @ts-ignore next-line */
      buttons={[]}
    />
  )
}

export default ManagerApproverExpenseReports
